module.exports = __webpack_public_path__ + "img/dsci0055.676a13d1.jpg";